


































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
@Component({
    components: {}
})
export default class Button extends Vue {
    @Prop({
        type: Number,
        default: 0
    })
    min!: number;
    @Prop({
        type: Number,
        default: 100
    })
    max!: number;
    @Prop({
        type: Number,
        default: 10
    })
    step!: number;
    @Prop({
        required: true
    })
    dataSource!: { [key: string]: number };
    curValue!: number;
    isEvent: boolean = true;
    isActive: number = 0;
    size!: number;
    ds!: number;
    stage!: HTMLElement;
    handle!: HTMLElement;
    track!: HTMLElement;
    maxDistance!: number;
    mark: number = 0;
    handleW: number = 0;
    tips: Array<number> = [];
    events: Array<any> = [];
    vector: {
        sx: number;
        ex: number;
        lx: number;
    } = {
        sx: 0,
        ex: 0,
        lx: 0
    };
    @Watch('dataSource')
    onUpValue(data: any) {
        this.isEvent = false;
        this.curValue = data.value;
        this.mark = (this.curValue - this.min) / this.step * this.ds;
        this.vector = {
            sx: 0,
            ex: 0,
            lx: 0
        };
        this.upTranslate(true);
    }
    onDragStart(ev: MouseEvent) {
        this.vector.sx = ev.clientX;
        document.addEventListener('mousemove', this.events[1]);
        document.addEventListener('mouseup', this.events[2]);
    }
    onDrag(ev: MouseEvent) {
        this.vector.ex = ev.clientX;
        this.upTranslate();
    }
    onDraGend(ev: MouseEvent) {
        this.vector.ex = ev.clientX;
        this.upTranslate(true);
        document.removeEventListener('mousedown', this.events[0]);
        document.removeEventListener('mousemove', this.events[1]);
        document.removeEventListener('mouseup', this.events[2]);
    }
    onMousedown() {
        this.mark = this.vector.lx;
        document.addEventListener('mousedown', this.events[0]);
    }
    upTranslate(auto: boolean = false) {
        let dx: number = this.vector.ex - this.vector.sx + this.mark;
        let transition: string = '';
        dx = Math.min(Math.max(dx, 0), this.maxDistance);
        if (auto) {
            this.isActive = Math.round(dx / this.ds);
            dx = this.ds * this.isActive;
            transition = 'transition: all 0.3s  ease-in-out';
            const value: number = this.min + this.isActive * this.step;
            if (value !== this.curValue) {
                this.curValue = value;
                if (this.isEvent) {
                    this.$emit('change', this.curValue);
                }
            }
        }
        this.isEvent = true;
        this.vector.lx = dx = dx - this.handleW / 2;
        this.track.style.cssText = `width:${dx}px;${transition}`;
        this.handle.style.cssText = `transform:translate(${dx}px,0);${transition}`;
    }
    created() {
        this.size = (this.max - this.min) / this.step;
        for (let i = 0; i <= this.size; i++) {
            this.tips.push(this.min + i * this.step);
        }
        this.events[0] = this.onDragStart.bind(this);
        this.events[1] = this.onDrag.bind(this);
        this.events[2] = this.onDraGend.bind(this);
    }
    upScale() {
        const mark: HTMLDivElement = this.$refs.mark as HTMLDivElement;
        const perch: HTMLDivElement = this.$refs.perch as HTMLDivElement;
        const marks: Array<HTMLSpanElement> = Array.from(
            mark.querySelectorAll('span')
        );
        const perchs: Array<HTMLSpanElement> = Array.from(
            perch.querySelectorAll('span')
        );
        [marks,perchs].forEach((data: Array<HTMLSpanElement>) => {
            data.forEach((span: HTMLSpanElement, index: number) => {
                let width: number = span.getBoundingClientRect().width / 2;
                let fx: number = this.ds * index - width;
                span.style.transform = `translate(${fx}px,0)`;
            });
        });
    }
    markClick(index: number) {
        const sum: number = (1 + index) * this.step;
        this.vector = {
            sx: 0,
            ex: 0,
            lx: 0
        };
        this.mark = (sum - this.min) / this.step * this.ds;
        this.upTranslate(true);
    }
    beforeDestroy() {
        document.removeEventListener('mousedown', this.events[0]);
        document.removeEventListener('mousemove', this.events[1]);
        document.removeEventListener('mouseup', this.events[2]);
        this.tips.length = 0;
        this.events.length = 0;
    }
    mounted() {
        this.stage = this.$refs.stage as HTMLElement;
        this.track = this.$refs.track as HTMLElement;
        this.handle = this.$refs.handle as HTMLElement;
        this.handleW = this.handle.getBoundingClientRect().width;
        this.maxDistance = this.stage.getBoundingClientRect().width;
        this.ds = this.maxDistance / this.size;
        this.curValue = this.dataSource.value;
        this.mark = (this.curValue - this.min) / this.step * this.ds;
        this.upScale();
        this.upTranslate(true);
    }
}
